import script from "./NavBreadcrumbItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavBreadcrumbItem.vue?vue&type=script&lang=ts&setup=true"

import "./NavBreadcrumbItem.vue?vue&type=style&index=0&id=4ac1543e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ac1543e"]])

export default __exports__